
import { UseAssessmentEditResult } from './types';
import { formatSlugString } from './utils';
import { useAssessmentState } from './useAssessmentState';
import { useSaveOperations } from './useSaveOperations';
import { useContentManagement } from './useContentManagement';
import { useAssessmentData } from './useAssessmentData';

// Main hook for editing assessments
export function useAssessmentEdit(id?: string): UseAssessmentEditResult {
  const {
    state,
    setLoading,
    setTitle,
    setDescription,
    setSlug,
    setCategories,
    setIsActive,
    setIsMaturityModel,
    setNotifyEmails,
    setCalendlyLink,
    setAssessment,
    setConfirmingVersionChange,
    populateAssessmentData,
  } = useAssessmentState();

  const { saveSettings, saveContent, handlePublish } = useSaveOperations({
    state,
    setLoading,
    setAssessment,
    setConfirmingVersionChange,
    populateAssessmentData,
    id,
  });

  const { isContentChanged, handleSubmit, cancelContentChanges, autoSaveContent } = useContentManagement({
    state,
    setConfirmingVersionChange,
    saveSettings,
    saveContent,
  });

  useAssessmentData({
    id,
    setLoading,
    setAssessment,
    populateAssessmentData,
  });

  // Format slug to be URL-friendly
  const formatSlug = (value: string) => {
    return formatSlugString(value);
  };

  return {
    ...state,
    setTitle,
    setDescription,
    setSlug,
    setCategories,
    setIsActive,
    setIsMaturityModel,
    setNotifyEmails,
    setCalendlyLink,
    formatSlug,
    handleSubmit,
    handlePublish,
    isContentChanged,
    cancelContentChanges,
    saveContent,
    autoSaveContent
  };
}
